/**
 * Standard ISO container type options.
 * value  = stored in DB (human-readable label)
 * label  = displayed in dropdown (includes ISO code for reference)
 */
export const CONTAINER_TYPE_OPTIONS = [
  { value: '20 High Cube',              label: '20 High Cube (20G0)' },
  { value: '20 Bulk',                   label: '20 Bulk (22B0)' },
  { value: '20 Standard Dry',           label: '20 Standard Dry (22G0)' },
  { value: '20 General Purpose',        label: '20 General Purpose (22G1)' },
  { value: '20 Insulated',              label: '20 Insulated (22H0)' },
  { value: '20 Flat Rack',              label: '20 Flat Rack (22P1)' },
  { value: '20 Collapsible Flat Rack',  label: '20 Collapsible Flat Rack (22P3)' },
  { value: '20 Reefer',                 label: '20 Reefer (22R1)' },
  { value: '20 Tank',                   label: '20 Tank (22T0)' },
  { value: '20 Open Top',               label: '20 Open Top (22U1)' },
  { value: '20 Ventilated',             label: '20 Ventilated (22VH)' },
  { value: '20 Bin Half Height',        label: '20 Bin Half Height Open Top (28U1)' },
  { value: '20 Platform',               label: '20 Platform (29P0)' },
  { value: '40 Standard Dry',           label: '40 Standard Dry (42G0)' },
  { value: '40 FT Dry Container',       label: '40 FT Dry Container (42G1)' },
  { value: '40 Insulated',              label: '40 Insulated (42H0)' },
  { value: '40 Flat Rack',              label: '40 Flat Rack (42P1)' },
  { value: '40 Collapsible Flat Rack',  label: '40 Collapsible Flat Rack (42P3)' },
  { value: '40 Reefer',                 label: '40 Reefer (42R1)' },
  { value: '40 Tank',                   label: '40 Tank (42T0)' },
  { value: '40 Open Top',               label: '40 Open Top (42U1)' },
  { value: '40 Ventilated',             label: '40 Ventilated (42VH)' },
  { value: '40 High Cube',              label: '40 High Cube (45G0)' },
  { value: '40 Reefer High Cube',       label: '40 Reefer High Cube (45R1)' },
  { value: '40 High Cube Hard Top',     label: '40 High Cube Hard Top (45UP)' },
  { value: '40 Platform',               label: '40 Platform (49P0)' },
  { value: '45 High Cube',              label: '45 High Cube (L5G1)' },
  { value: '45 Reefer High Cube',       label: '45 Reefer High Cube (L5R1)' },
];
